import { useQuery } from '@tanstack/react-query';
import styles from './ProspectAdmin.module.css';

type Prospect = {
  id: string;
  name?: string;
  phone?: string;
  email?: string;
  created_at?: string;
};

async function fetchProspects(): Promise<Prospect[]> {
  const response = await fetch('/api/prospects');
  if (!response.ok) throw new Error(`Error: ${response.status}`);
  const data = await response.json();
  return (data?.prospects ?? data) as Prospect[];
}

export default function ProspectAdmin() {
  const { data: prospects = [], isLoading, isError } = useQuery({
    queryKey: ['prospects'],
    queryFn: fetchProspects,
  });

  const formatDate = (dateString?: string) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  return (
    <div className={styles.container}>
      <div className={styles.overlay} />
      <h1 className={styles.title}>Prospects</h1>

      <div className={styles.content}>
        <div className={styles.listSection}>
          <h2>Prospect List</h2>

          {isError && <div className={styles.errorMessage}>Failed to fetch prospects</div>}

          {isLoading ? (
            <div className={styles.loading}>Loading prospects...</div>
          ) : prospects.length === 0 ? (
            <div className={styles.emptyMessage}>No prospects found</div>
          ) : (
            <table className={styles.table}>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Phone</th>
                  <th>Email</th>
                  <th>Submitted</th>
                </tr>
              </thead>
              <tbody>
                {prospects.map(prospect => (
                  <tr key={prospect.id} className={styles.prospectRow}>
                    <td>{prospect.name || '-'}</td>
                    <td>{prospect.phone || '-'}</td>
                    <td>{prospect.email || '-'}</td>
                    <td>{formatDate(prospect.created_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
